import styles from './ButtonLoader.module.css';

export const ButtonLoader = () => {
  return <span className={styles.loader}></span>;
};